module.exports = __webpack_public_path__ + "img/app_ios_d.47e37f6a.png";